import { Container } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import classes from "./Footer.module.css";
import logo from "../../Assets/logo.png";
import site from "../../data/site";
import { requestBookCall } from "../../lib/bookCall";

function Footer() {
  const navigate = useNavigate();
  const year = new Date().getFullYear();

  return (
    <footer className={classes.footer}>
      <Container>
        <div className={classes.cta}>
          <h2>Let’s talk about the work.</h2>
          <p>
            Software, marketing, AI automations, GoHighLevel, design, and
            virtual assistance — scoped to what will move your business.
          </p>
          <button
            type="button"
            onClick={() => requestBookCall(navigate)}
            className="buttonHome"
          >
            Book a Call
          </button>
        </div>
        <nav className={classes.navLinks} aria-label="Footer">
          <Link to="/">Home</Link>
          <Link to="/services">Services</Link>
          <Link to="/about">About</Link>
          <Link to="/#process">Process</Link>
          {site.services.map((service) => (
            <Link key={service.slug} to={`/services/${service.slug}`}>
              {service.title}
            </Link>
          ))}
        </nav>
        <address className={classes.details}>
          Fully remote team based in {site.address.locality},{" "}
          {site.address.countryName}. Serving clients worldwide.
          <span className={classes.contactRow}>
            <a href={`tel:${site.phone}`}>{site.phoneDisplay}</a>
            <a href={`mailto:${site.email}`}>{site.email}</a>
          </span>
        </address>
        <div className={classes.meta}>
          <div className={classes.brand}>
            <img src={logo} alt="" />
            <span>DigitaliNation</span>
          </div>
          <div className={classes.copy}>Copyright © 2024 - {year}</div>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
